import uiI18n from "../i18n";
const PUBLIC_SITE_URL = process.env.REACT_APP_PUBLIC_SITE_URL || 'https://www.linaimmo.com';
export async function shareListing(kind, listing) {
  const id = listing.id || listing.ID;
  const url = kind === 'vacation'
    ? new URL(`/DetailsVacation/${encodeURIComponent(id)}`, window.location.origin).href
    : new URL(`/listing/${encodeURIComponent(id)}`, PUBLIC_SITE_URL).href;
  const title = listing.libelle || uiI18n.t("ui.listing_brand");
  const price = listing.offre && Number(listing.prixReduit)>0 ? listing.prixReduit : listing.prix;
  const text = [title, price ? `${price} TND` : '', [listing.delegation,listing.ville].filter(Boolean).join(', ')].filter(Boolean).join('\n');
  if(navigator.share) { await navigator.share({title,text,url}); return ''; }
  await navigator.clipboard.writeText(url);
  return uiI18n.t("ui.link_copied");
}
